module.exports = __webpack_public_path__ + "static/features-iphone-bottom-f3bb303f749cf77019e4e5d5017b6a58.png";